module.exports = __webpack_public_path__ + "img/head.4178b2c5.png";